const stickyAtcBarAttr = {
  observe: 'data-sticky-atc-bar-observe',
  btn: 'data-sticky-atc-bar-btn',
  panel: 'data-sticky-atc-bar-panel',
}

if (!customElements.get('sticky-atc-bar')) {
  customElements.define('sticky-atc-bar', class extends HTMLElement {
    connectedCallback() {
      const targetSelector = this.getAttribute(stickyAtcBarAttr.observe)
      if (!targetSelector) return

      this.target = document.querySelector(targetSelector)
      if (!this.target) return

      this.mql = window.matchMedia('(max-width: 1023px)')

      this.observer = new IntersectionObserver(([entry]) => {
        if (!this.mql.matches) {
          this.removeAttribute('stuck')
          return
        }
        if (entry.isIntersecting) {
          this.removeAttribute('stuck')
          this.toggleZendeskLauncher(true)
        } else if (entry.boundingClientRect.top < 0) {
          this.setAttribute('stuck', '')
          this.toggleZendeskLauncher(false)
        }
      }, { threshold: 0 })

      this.observer.observe(this.target)

      this.mql.addEventListener('change', () => {
        if (!this.mql.matches) {
          this.removeAttribute('stuck')
          this.toggleZendeskLauncher(true)
        }
      })

      const stickyBtn = this.querySelector(`[${stickyAtcBarAttr.btn}]`)
      if (stickyBtn) {
        stickyBtn.addEventListener('click', () => {
          const form = this.target.querySelector('form:not([hidden])')
          if (form) form.requestSubmit()
        })
      }

      this.syncButton()
      this.targetObserver = new MutationObserver(() => this.syncButton())
      this.targetObserver.observe(this.target, { subtree: true, attributes: true, childList: true, characterData: true })
    }

    toggleZendeskLauncher(show) {
      const launcher = document.getElementById('launcher')
      if (launcher) launcher.style.display = show ? '' : 'none'
    }

    syncButton() {
      const realBtn = this.target?.querySelector('button[type="submit"]')
      const stickyBtn = this.querySelector(`[${stickyAtcBarAttr.btn}]`)
      if (!realBtn || !stickyBtn) return

      const formHidden = realBtn.closest('form')?.hidden
      stickyBtn.disabled = realBtn.disabled || !!formHidden
      const text = realBtn.querySelector('span')?.textContent?.trim()
      if (text) stickyBtn.textContent = text
    }

    disconnectedCallback() {
      this.observer?.disconnect()
      this.targetObserver?.disconnect()
      this.toggleZendeskLauncher(true)
    }
  })
}
